// extracted by mini-css-extract-plugin
export default {"confirmContainer":"confirmOkpd_confirmContainer__jDipI"};